import {useQueryState} from 'shared/web';

const THEME_ID_QUERY_KEY = 'theme';

export function useThemeId() {
  const [themeId] = useQueryState(THEME_ID_QUERY_KEY);

  return themeId;
}
